import { FC, memo, useRef, useState } from 'react';
import { Overlay, Pagination, Popover } from 'react-bootstrap';

import { addPageItems } from '../helper';
import { PaginationPopupProps } from './types';

export const PaginationPopup: FC<PaginationPopupProps> = memo(({ prevPageNumber, nextPageNumber, onClickHandler }) => {
    const [target, setTarget] = useState(null),
        onClickHandlerWrapper = (pageNumber: any) => (e) => {
            setTarget(e.target);
            onClickHandler(pageNumber);
        };
    const [show, setShow] = useState(false);
    const ref = useRef(null);
    const handleClick = (event) => {
        setShow(!show);
        setTarget(event.target);
    };
    return (
        <div ref={ref}>
            <Pagination.Ellipsis onClick={handleClick} />
            <Overlay show={show} target={target} placement="bottom" container={ref} containerPadding={20}>
                <Popover id="popover-contained">
                    <Popover.Header as="h3">Select page</Popover.Header>
                    <Popover.Body>
                        <Pagination.Item key={`${prevPageNumber}...`}>...</Pagination.Item>
                        {addPageItems(prevPageNumber + 1, nextPageNumber - 1, []).map((item, index) => (
                            <Pagination.Item key={index} onClick={onClickHandlerWrapper(item)}>
                                {item}
                            </Pagination.Item>
                        ))}
                    </Popover.Body>
                </Popover>
            </Overlay>
        </div>
    );
});
PaginationPopup.displayName = 'PaginationPopup';
